import { AbstractControl, ValidatorFn } from '@angular/forms';

export const consecutiveSpaceValidator = (): ValidatorFn => (
  control: AbstractControl
): { [key: string]: any } | null => {
  const regex = /\S\s+(?: \S+)/g;

  const isHaveConsecutiveSpaces = control.value.search(regex);

  return isHaveConsecutiveSpaces !== -1 ? { consecutiveSpaces: true } : null;
};
